/**
 * @author salla.sai shiva
 * @Date: 2022-11-04 16:20:30
 * @Last Modified by: salla.sai shiva
 * @Last Modified time: 2022-11-04 16:50:30
*/

import React, { Fragment } from 'react';
import { Row, Col, Card, Collapse, Icon, Modal, Button, Checkbox } from 'antd';
import { shape } from 'prop-types';
import { AppWrappperHOC } from '../../Root/HOC';
import Journey from '../../../containers/NewLanding/Journey';
import { Container, HelmetWrapper } from '../../../components';
import { StyledAnnualFinancials } from '../StyledStaticPages';
import { COLLAPSE_ANNUAL_FINANCIALS } from './constants';
import { IMG_IMPORTS, PDF_IMPORTS } from '../../../devUtils/assests';
import endPoints from '../../../config/endPoints';
import { constants } from '../../../devUtils';

const { Panel } = Collapse;

class AnnualGeneralMeeting extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      activeModal: '',
      isDoNotConfirm: false,
      isChecked: false,
    };
    this.handleChecked = this.handleChecked.bind(this);
  }


  handleModal(_activeModal) {
    this.setState({ activeModal: _activeModal });
  }

  handleChecked(evt) {
    this.setState({ isChecked: evt.target.checked });
  }

  renderResourcesCollapse() {
    const { RESOURCES_COLLAPSE } = COLLAPSE_ANNUAL_FINANCIALS;
    return (
      <Collapse
        expandIconPosition="right"
        bordered={false}
        className="collapse-grill"
      >
        {RESOURCES_COLLAPSE.length && RESOURCES_COLLAPSE.map(({ keyIndex, headers, dataSlug }) => (
          <Panel
            header={<strong className="font-16">{headers}</strong>}
            key={keyIndex}
          >
            {dataSlug && dataSlug.map(({ id, title, dataUrl }) => (
              <Row key={id} className="padding-t-1" align="middle" type="flex" justify="start" gutter={18}>
                <Col xs={24} sm={24} md={dataUrl ? 18 : 24} lg={dataUrl ? 18 : 24} xl={dataUrl ? 18 : 24}>
                  <div dangerouslySetInnerHTML={{ __html: title }} />
                </Col>
                {dataUrl ?
                  <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                    <a href={dataUrl} target="_blank" >
                      <Icon type="file-pdf" className="margin-r-1 font-18" /> PDF
                    </a>
                  </Col> : ''
                }

              </Row>
            ))}
          </Panel>
        ))}
      </Collapse>
    );
  }

  renderDisclosuresCollapse() {
    return (
      <Collapse
        expandIconPosition="right"
        bordered={false}
        className="collapse-grill"
      >
        <a
          href={constants.LINK_DISCLOSURES_REGULATION}
          target="_blank"
          className="anchor-link-single cursor"
        >Disclosures under Regulation 46 of the LODR
        </a>
      </Collapse>
    );
  }

  renderModalBody() {
    const {
      activeModal,
    } = this.state;
    switch (activeModal) {
      case 'MCMD':
        return this.renderMCMDBody();
      case 'RHP':
        return this.renderRHPBody();
      default:
        return <div />;
    }
  }

  renderFinancialCollapse() {
    const { RELATED_PART_TRANSACTIONS } = COLLAPSE_ANNUAL_FINANCIALS;
    return (
      <Collapse
        expandIconPosition="right"
        bordered={false}
        className="collapse-grill"
      >
        <a
          href={constants.FINANCIALS}
          target="_blank"
          className="anchor-link-single cursor"
        >Financials
        </a>
        <a
          href={RELATED_PART_TRANSACTIONS}
          target="_blank"
          className="anchor-link-single cursor"
        >Related Party Transactions
        </a>
        {/* <Panel
          header={<strong className="font-16">Results, Reports & Presentations</strong>}
          key="01"
        >
          <Collapse
            expandIconPosition="right"
            bordered={false}
            className="collapse-grill"
          >
            <Panel
              header={<strong className="font-16">2020-2021</strong>}
              key="001"
            >
              <Row className="padding-t-1" align="middle" type="flex" justify="start" gutter={18}>
                <Col xs={24} sm={24} md={16} lg={16} xl={16}>
                  2020-2021
                </Col>
                <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                  <a href={PDF_IMPORTS.FINANCIAL_STATEMENTS_11} target="_blank" >
                    <Icon type="file-pdf" className="margin-r-1 font-18" /> PDF
                  </a>
                </Col>
              </Row>
            </Panel>
            <Panel
              header={<strong className="font-16">2021-2022</strong>}
              key="002"
            >
              <Row className="padding-t-1" align="middle" type="flex" justify="start" gutter={18}>
                <Col xs={24} sm={24} md={16} lg={16} xl={16}>
                  2021-2022
                </Col>
                <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                  <a href={PDF_IMPORTS.FINANCIAL_STATEMENTS_12} target="_blank" >
                    <Icon type="file-pdf" className="margin-r-1 font-18" /> PDF
                  </a>
                </Col>
              </Row>
            </Panel>
            <Panel
              header={<strong className="font-16">2022-2023</strong>}
              key="003"
            >
              <Row className="padding-t-1" align="middle" type="flex" justify="start" gutter={18}>
                <Col xs={24} sm={24} md={16} lg={16} xl={16}>
                  2022-2023
                </Col>
                <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                  <a href={PDF_IMPORTS.FINANCIAL_STATEMENTS_13} target="_blank" >
                    <Icon type="file-pdf" className="margin-r-1 font-18" /> PDF
                  </a>
                </Col>
              </Row>
            </Panel>
          </Collapse>
        </Panel>
        {FINANCIALS_COLLAPSE.length && FINANCIALS_COLLAPSE.map(({ keyIndex, headers, dataSlug }) => (
          <Panel
            header={<strong className="font-16">{headers}</strong>}
            key={keyIndex}
          >
            {dataSlug && dataSlug.map(({ id, title, dataUrl }) => (
              <Row key={id} className="padding-t-1" align="middle" type="flex" justify="start" gutter={18}>
                <Col xs={24} sm={24} md={18} lg={18} xl={18}>
                  {title}
                </Col>
                <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                  <a href={dataUrl} target="_blank" >
                    <Icon type="file-pdf" className="margin-r-1 font-18" /> PDF
                  </a>
                </Col>
              </Row>
            ))}
          </Panel>
        ))} */}
      </Collapse>
    );
  }

  renderCorporateCollapse() {
    const { CORPORATE_COLLAPSE } = COLLAPSE_ANNUAL_FINANCIALS;
    return (
      <Fragment>
        <Collapse
          expandIconPosition="right"
          bordered={false}
          className="collapse-grill"
        >
          <div className="margin-b-1">
            <a
              href={constants.BOARD_OF_DIRECTORS}
              target="_blank"
              className="anchor-link-single"
            >
              <strong className="font-16">Board of Directors</strong>
            </a>
          </div>
          {CORPORATE_COLLAPSE.length && CORPORATE_COLLAPSE.map(({ keyIndex, headers, dataSlug }) => (
            <Panel
              header={<strong className="font-16">{headers}</strong>}
              key={keyIndex}
            >
              {dataSlug && dataSlug.map(({ id, title, dataUrl }) => (
                <Row key={id} className="padding-t-1" align="middle" type="flex" justify="start" gutter={18}>
                  <Col xs={24} sm={24} md={18} lg={18} xl={18}>
                    {title}
                  </Col>
                  <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                    <a href={dataUrl} target="_blank" >
                      <Icon type="file-pdf" className="margin-r-1 font-18" /> PDF
                    </a>
                  </Col>
                </Row>
              ))}
            </Panel>
          ))}
          <div className="margin-b-2">
            <a
              href="https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/code-of-practices-and-procedures-for-fair-disclosure-of-unpublished-price-sensitive-information.pdf"
              target="_blank"
              className="anchor-link-single"
            >
              <strong className="font-16">Code of Practices & Procedures for Fair Disclosure</strong>
            </a>
          </div>
          <div className="margin-b-2">
            <a
              href="https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/disclosures-regulation/code-of-conduct-for-board-members-and-senior-management.pdf"
              target="_blank"
              className="anchor-link-single"
            >
              <strong className="font-16">Code of Conduct</strong>
            </a>
          </div>
          <div className="margin-b-2">
            <a
              href={constants.AUDIT_COMMITTEE}
              target="_blank"
              className="anchor-link-single"
            >
              <strong className="font-16">Board Committees</strong>
            </a>
          </div>
          <Button
            className="cursor anchor-link-single"
            onClick={() => this.handleModal('RHP')}
          >Prospectus
          </Button>
          <div className="margin-b-2">
            <a
              href={PDF_IMPORTS.BASIS_OF_ALLOTMENT}
              target="_blank"
              className="anchor-link-single"
            >
              <strong className="font-16">Basis of Allotment</strong>
            </a>
          </div>
          <Button
            className="cursor anchor-link-single"
            onClick={() => this.handleModal('MCMD')}
          >Material Contracts Material Documents
          </Button>
          <div className="margin-b-2">
            <a
              href={PDF_IMPORTS.DETAILS_OF_CREDITORS}
              target="_blank"
              className="anchor-link-single"
            >
              <strong className="font-16">Details of Creditors</strong>
            </a>
          </div>
        </Collapse>
      </Fragment>
    );
  }

  renderMCMDBody() {
    return (
      <Fragment>
        <div className="padding-2" style={{ maxHeight: '400px', overflow: 'auto' }}>
          <div>
            <p>
              <strong>Important: Please read this disclaimer carefully before reading, accessing or making any other use of the materials and documents available on this website.<br /><br /></strong>

              The following disclaimer applies to the material contracts and documents for inspection (“<strong>Material Contracts and Documents</strong>”) as identified in the section entitled “Material Contracts and Documents for Inspection” of the Red Herring Prospectus dated September 8, 2023 (the “<strong>Red Herring Prospectus</strong>” or “<strong>RHP</strong>”), in relation to the proposed initial public offering of the equity shares bearing face value of ₹1 each (the “<strong>Equity Shares</strong>”) of Zaggle Prepaid Ocean Services Limited (the “<strong>Company</strong>”, and such offer, the “<strong>Offer</strong>”).<br /><br />
              The Material Contracts and Documents for inspection have been made available on our website to comply with the Securities and Exchange Board of India (Issue of Capital and Disclosure Requirements) Regulations, 2018, as amended. Access to the Material Contracts and Documents does not constitute a recommendation by the Company, the Selling Shareholders (as defined in the RHP), the members of the Syndicate (as defined in the RHP) or any of their respective affiliates or any other person to subscribe to the Equity Shares offered in the Offer.<br /><br />
              The statements contained in the Material Contracts and Documents speak only as at the date as of which they are made, and the Company expressly disclaims any obligation or undertaking to supplement, amend or disseminate any updates or revisions to any statements contained therein to reflect any change in events, conditions or circumstances on which any such statements are based. These documents do not constitute and should not be construed as an offer to sell or issue or recommendation or solicitation of an offer to buy Equity Shares in any jurisdiction or as an inducement to enter into investment activity. No part of these documents should form the basis of, or be relied on in connection with, any contract or commitment or investment decision whatsoever.<br /><br />
              You acknowledge and agree that the Material Contracts and Documents may contain confidential information. The Company only authorizes you to inspect the Material Contracts and Documents in accordance with the requirements of applicable laws in relation to the Offer. The Material Contracts and Documents may not be photographed, sold, reproduced, or distributed under any circumstances and for any purposes whatsoever. Any other rights not specifically granted herein are reserved.<br /><br />
              You are accessing this website at your own risk. None of the Company or any of its affiliates or their respective directors, officers or employees will be liable or have any responsibility of any kind for any loss or damage that you incur in the event of any failure or disruption of this website, or resulting from the act or omission of any other party involved in making this website or the data contained therein available to you, or from any other cause relating to your access to, inability to access, or use of the website or these materials. The Company or any of its affiliates or their respective directors, officers or employees shall not be responsible for any loss or damage that could result from interception and interpretation by any third parties of any information being made available to you through this website. You are reminded that documents transmitted in electronic form may be altered or changed during the process of transmission and consequently none of the Company or any of its affiliates or their respective directors, officers or employees accepts any liability or responsibility whatsoever in respect of alterations or changes which may have taken place during the course of transmission of the Material Contracts and Documents in electronic format.<br /><br />
              You are responsible for protecting against viruses and other destructive items. You are accessing this website at your own risk and it is your responsibility to take precautions to ensure that it is free from viruses and other items of a destructive nature.<br /><br />
              Any claims arising out of the use of the information from these documents shall be governed by the laws of India and only the courts in India, and no other courts, shall have jurisdiction over such matters.<br /><br />
              The Material Contracts and Documents may not be accessed by persons in the United States.<br /><br />
              <strong>Confirmation</strong><br /><br />
              By accessing these documents and by clicking on the “I Confirm” button below, you represent to the Company, the Selling Shareholders and the members of the Syndicate that you are not in the United States and that you have read and accept the foregoing and you agree to be bound by its terms.<br /><br />
            </p>
            <div className="text-center">
              <a href={constants.LINK_MCMD} className="btn green-btn margin-t-1 margin-b-1 margin-l-2">
                I confirm
              </a>
            </div>
            <i className="font-12">
            The Company is proposing, subject to receipt of requisite approvals, market conditions and other considerations, to make an initial public offer of its Equity Shares has filed the RHP with the Registrar of Companies, Telangana at Hyderabad, and thereafter with the SEBI and the Stock Exchanges. The RHP is available on the website of the Company at www.zaggle.in/investor-relations, the website of SEBI at www.sebi.gov.in, the websites of the Stock Exchanges, i.e., BSE and NSE at www.bseindia.com and www.nseindia.com, respectively, and as well as on the websites of the BRLMs, i.e., ICICI Securities Limited, Equirus Capital Private Limited, IIFL Securities Limited and JM Financial Limited at www.icicisecurities.com, www.equirus.com, www.iiflcap.com and www.jmfl.com, respectively. Potential investors should note that investment in equity shares involves a high degree of risk and for details relating to such risk, please see the section entitled “Risk Factors” on page 31 of the RHP. Potential investors should not rely on the Draft Red Herring Prospectus dated December 19, 2022 filed with SEBI for making any investment decision.<br /><br />
            The Equity Shares offered in the Offer have not been and will not be registered, listed or otherwise qualified in any jurisdiction except India and may not be offered or sold to persons outside of India except in compliance with the applicable laws of each such jurisdiction. In particular, the Equity Shares offered in the Offer have not been and will not be registered under the U.S. Securities Act of 1933, as amended (the “<strong>U.S. Securities Act</strong>”), or the securities laws of any state of the United States and may not be offered or sold within the United States, except pursuant to an exemption from, or in a transaction not subject to, the registration requirements of the U.S. Securities Act and applicable state securities laws. The Equity Shares are being offered and sold only to persons outside the United States in reliance on Regulation S under the U.S. Securities Act.
            </i>
          </div>
        </div>
      </Fragment>
    );
  }

  renderRHPBody() {
    const {
      isDoNotConfirm,
      isChecked,
    } = this.state;
    return (
      <Fragment>
        <div className="padding-2" style={{ maxHeight: '400px', overflow: 'auto' }}>
          {isDoNotConfirm ?
            <h2 className="text-center">You are not permitted to view the materials in this section of the website.</h2> :
            <div>
              <strong>Important Disclaimer</strong>
              <p>PLEASE READ THIS DISCLAIMER CAREFULLY AND AGREE WITH THE TERMS AND CONDITIONS OF THIS DISCLAIMER BEFORE CONTINUING. IT APPLIES TO ALL PERSONS WHO VIEW THIS WEBSITE. PLEASE NOTE THAT THE DISCLAIMER SET OUT BELOW MAY BE ALTERED OR UPDATED. YOU SHOULD READ IT IN FULL EACH TIME YOU VISIT THE WEBSITE.</p>
              <strong>THESE MATERIALS ARE NOT DIRECTED AT OR INTENDED TO BE ACCESSED BY PERSONS OUTSIDE INDIA.</strong><br />
              <strong>THE PROSPECTUS HAS BEEN MADE AVAILABLE ON OUR WEBSITE TO COMPLY WITH THE SECURITIES AND EXCHANGE BOARD OF INDIA (ISSUE OF CAPITAL AND DISCLOSURE REQUIREMENTS) REGULATIONS, 2018, AS AMENDED.</strong><br /><br />
              <p>
              The following disclaimer applies to the prospectus dated September 18, 2023 (the “Prospectus”) in relation to the proposed initial public offering of the equity shares (“Equity Shares”) of Zaggle Prepaid Ocean Services Limited (the “Company”) (the “Offer”). You are advised to read this disclaimer carefully before reading, accessing or making any other use of the Prospectus. By accessing the Prospectus, you agree to be bound by the following terms and conditions, including any modifications to them from time to time.<br /><br />
              Access to the Prospectus does not constitute a recommendation by the Company, the Selling Shareholders (as defined in the Prospectus), the members of the Syndicate (as defined in the Prospectus) or any of their respective affiliates or any other person to subscribe to the Equity Shares offered in the Offer.<br /><br />
              The information in the Prospectus is as of the date thereof and none of the Company, the Selling Shareholders, the members of the Syndicate or their respective affiliates or any of the Company’s, the Selling Shareholders’ or the members of the Syndicate’s respective directors or employees are under any obligation to update or revise the Prospectus to reflect circumstances arising after the date thereof. The Company cannot and does not guarantee the accuracy, timeliness or completeness of the information in the Prospectus beyond the date of the Prospectus.<br /><br />
              The Equity Shares offered in the Offer have not been and will not be registered, listed or otherwise qualified in any jurisdiction except India and may not be offered or sold outside of India except in compliance with the applicable laws of each such jurisdiction. In particular, the Equity Shares offered in the Offer have not been and will not be registered under the U.S. Securities Act of 1933, as amended (the “U.S. Securities Act”), or the securities laws of any state of the United States and may not be offered or sold within the United States, except pursuant to an exemption from, or in a transaction not subject to, the registration requirements of the U.S. Securities Act and applicable state securities laws. The Equity Shares were offered and are being sold only to persons outside the United States in reliance on Regulation S under the U.S. Securities Act.<br /><br />
              The copy of the Prospectus hosted on this website may not be distributed, directly or indirectly, outside India. You are hereby notified that any forwarding, delivery or distribution of the Prospectus, in whole or in part, outside India is strictly prohibited. Failure to comply with this disclaimer may result in a violation of the applicable laws. If you access the Prospectus, you agree not to forward, deliver or distribute it, in whole or in part, to any person outside India.<br /><br />
                <strong>Investors should note that investment in equity shares involves a high degree of risk and for details relating to such risks, see the section titled “Risk Factors” of the Prospectus.</strong><br /><br />
              You are accessing this website at your own risk. None of the Company or any of its affiliates or their respective directors, officers or employees will be liable or have any responsibility of any kind for any loss or damage that you incur in the event of any failure or disruption of this website, or resulting from the act or omission of any other party involved in making this website or the data contained therein available to you, or from any other cause relating to your access to, inability to access, or use of the website or these materials.<br /><br />
              The Company or any of its affiliates or their respective directors, officers or employees shall not be responsible for any loss or damage that could result from interception and interpretation by any third parties of any information being made available to you through this website. You are reminded that documents transmitted in electronic form may be altered or changed during the process of transmission and consequently none of the Company or any of its affiliates or their respective directors, officers or employees accepts any liability or responsibility whatsoever in respect of alterations or changes which may have taken place during the course of transmission of the Prospectus in electronic format.<br /><br />
              You are responsible for protecting against viruses and other destructive items. You are accessing this website at your own risk and it is your responsibility to take precautions to ensure that it is free from viruses and other items of a destructive nature.<br /><br />
              If you are not in India, please exit this webpage.<br /><br />
                <strong>Confirmation of your acceptance of the terms and conditions</strong><br /><br />
                By clicking on the “I Confirm” button below you represent to the Company and the members of the Syndicate that:<br /><br />
                1. You have read the disclaimer set out above and you agree to be bound by its terms; and<br />
                2. You are located in India.<br /><br />
                If you cannot make these confirmations, you must press the button marked “I Do Not Confirm”.<br /><br />
              </p>
            </div>
          }
        </div>
        <div className="text-center padding-t-2">

          {!isDoNotConfirm ?
            <Checkbox onChange={this.handleChecked} checked={isChecked}>
              <i><strong>I have read the above disclaimer and I agree to be bound by its terms. I hereby declare that I am located in India.</strong></i>
            </Checkbox> : ''
          }
          {!isDoNotConfirm && !isChecked ?
            <button onClick={() => this.setState({ isDoNotConfirm: true })} className="btn red-btn margin-t-1 margin-b-1 cursor">
          I do not confirm
            </button> : ''}
          {isDoNotConfirm ?
            <button onClick={() => this.setState({ isDoNotConfirm: false, activeModal: '' })} className="btn red-btn margin-t-1 margin-b-1 cursor">
          Close
            </button> : ''}
          {!isDoNotConfirm && isChecked ?
            <a href={PDF_IMPORTS.ROSPECTUS} onClick={() => this.setState({ isDoNotConfirm: false, activeModal: '' })} target="_blank" className="btn green-btn margin-t-1 margin-b-1 margin-l-2">
          I confirm
            </a> : ''}
        </div>
      </Fragment>
    );
  }

  renderShareholderInformationCollapse() {
    const { SHAREHOLDER_INFORMATION_COLLAPSE } = COLLAPSE_ANNUAL_FINANCIALS;
    return (
      <Collapse
        expandIconPosition="right"
        bordered={false}
        className="collapse-grill"
      >
        {SHAREHOLDER_INFORMATION_COLLAPSE.length && SHAREHOLDER_INFORMATION_COLLAPSE.map(({ keyIndex, headers, dataSlug }) => (
          <Panel
            header={<strong className="font-16">{headers}</strong>}
            key={keyIndex}
          >
            {dataSlug && dataSlug.map(({ id, title, dataUrl }) => (
              <Row key={id} className="padding-t-1" align="middle" type="flex" justify="start" gutter={18}>
                <Col xs={24} sm={24} md={dataUrl ? 18 : 24} lg={dataUrl ? 18 : 24} xl={dataUrl ? 18 : 24}>
                  <div dangerouslySetInnerHTML={{ __html: title }} />
                </Col>
                {dataUrl ?
                  <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                    <a href={dataUrl} target="_blank" >
                      <Icon type="file-pdf" className="margin-r-1 font-18" /> PDF
                    </a>
                  </Col> : ''
                }
              </Row>
            ))}
          </Panel>
        ))}
      </Collapse>
    );
  }


  render() {
    const {
      history: {
        location,
      } = {},
    } = this.props;
    const {
      activeModal,
    } = this.state;
    return (
      <Fragment>
        <Modal
          visible={!!activeModal}
          closable={false}
          width="800px"
          maskClosable={false}
          footer={null}
          onCancel={() => this.handleModal('')}
        >
          {this.renderModalBody()}
        </Modal>
        <StyledAnnualFinancials>
          <HelmetWrapper location={location} />
          <div className="gray-greadient">
            <section className="padding-tb-5">
              <Container>
                <Row align="top" type="flex" justify="start" gutter={18}>
                  <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                    <Card className="card-padding-10 rounded">
                      <img src={IMG_IMPORTS.ANNUAL_INVESTOR_REPORT.URL} alt={IMG_IMPORTS.ANNUAL_INVESTOR_REPORT.ALT} />
                      <h2>Financials</h2>
                      {this.renderFinancialCollapse()}
                    </Card>
                    <Card className="card-padding-10 rounded margin-t-2">
                      <img src={endPoints.MERCHANT_BRAND_AWARENESS} alt="Disclosures" className="width-3 image-grayscale" />
                      <h2>Disclosures</h2>
                      {this.renderDisclosuresCollapse()}
                    </Card>
                  </Col>
                  <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                    <Card className="card-padding-10 rounded">
                      <img src={IMG_IMPORTS.ANNUAL_INVESTOR_TEAM.URL} alt={IMG_IMPORTS.ANNUAL_INVESTOR_TEAM.ALT} />
                      <h2>Corporate Governance</h2>
                      {this.renderCorporateCollapse()}
                    </Card>
                  </Col>
                  <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                    <Card className="card-padding-10 rounded">
                      <img src={IMG_IMPORTS.ANNUAL_INVESTOR_CONTACT_MAIL.URL} alt={IMG_IMPORTS.ANNUAL_INVESTOR_CONTACT_MAIL.ALT} />
                      <h2>Investor Information</h2>
                      {this.renderResourcesCollapse()}
                    </Card>
                    <Card className="card-padding-10 rounded margin-t-2">
                      <img
                        src={IMG_IMPORTS.SHAREHOLDER_INFORMATION.URL}
                        alt={IMG_IMPORTS.SHAREHOLDER_INFORMATION.ALT}
                        className="width-2 image-grayscale margin-b-2"
                      />
                      <h2>Shareholder Information</h2>
                      {this.renderShareholderInformationCollapse()}
                      <Collapse
                        expandIconPosition="right"
                        bordered={false}
                        className="collapse-grill"
                      >
                        <Panel
                          header={<strong className="font-16">Intimation to Stock Exchange</strong>}
                          key="01"
                        >
                          <Collapse
                            expandIconPosition="right"
                            bordered={false}
                            className="collapse-grill"
                          >
                            <Panel
                              header={<strong className="font-16">Awarding, bagging/ receiving contracts</strong>}
                              key="001"
                            >
                              <Row className="padding-t-1" align="middle" type="flex" justify="start" gutter={18}>
                                <Col xs={24} sm={24} md={16} lg={16} xl={16}>
                                Intimation of Execution of Contract with BFSL
                                </Col>
                                <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                  <a href={PDF_IMPORTS.STOCK_EXCHANGE_01} target="_blank" >
                                    <Icon type="file-pdf" className="margin-r-1 font-18" /> PDF
                                  </a>
                                </Col>
                              </Row>
                              <Row className="padding-t-1" align="middle" type="flex" justify="start" gutter={18}>
                                <Col xs={24} sm={24} md={16} lg={16} xl={16}>
                                Intimation of Execution of Contract with Visa
                                </Col>
                                <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                  <a href={PDF_IMPORTS.STOCK_EXCHANGE_03} target="_blank" >
                                    <Icon type="file-pdf" className="margin-r-1 font-18" /> PDF
                                  </a>
                                </Col>
                              </Row>
                              <Row className="padding-t-1" align="middle" type="flex" justify="start" gutter={18}>
                                <Col xs={24} sm={24} md={16} lg={16} xl={16}>
                                Intimation of Execution of Contract with Kotak
                                </Col>
                                <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                  <a href={PDF_IMPORTS.STOCK_EXCHANGE_04} target="_blank" >
                                    <Icon type="file-pdf" className="margin-r-1 font-18" /> PDF
                                  </a>
                                </Col>
                              </Row>
                              <Row className="padding-t-1" align="middle" type="flex" justify="start" gutter={18}>
                                <Col xs={24} sm={24} md={16} lg={16} xl={16}>
                                Intimation of Execution of Contract with Toshiba
                                </Col>
                                <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                  <a href={PDF_IMPORTS.STOCK_EXCHANGE_05} target="_blank" >
                                    <Icon type="file-pdf" className="margin-r-1 font-18" /> PDF
                                  </a>
                                </Col>
                              </Row>
                            </Panel>
                            <Panel
                              header={<strong className="font-16">Investor/ Analysts Meet</strong>}
                              key="002"
                            >
                              <Row className="padding-t-1" align="middle" type="flex" justify="start" gutter={18}>
                                <Col xs={24} sm={24} md={16} lg={16} xl={16}>
                                Intimation of Investor or Analysts-Meet on 22-11-2023
                                </Col>
                                <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                  <a href={PDF_IMPORTS.STOCK_EXCHANGE_07} target="_blank" >
                                    <Icon type="file-pdf" className="margin-r-1 font-18" /> PDF
                                  </a>
                                </Col>
                              </Row>
                              <Row className="padding-t-1" align="middle" type="flex" justify="start" gutter={18}>
                                <Col xs={24} sm={24} md={16} lg={16} xl={16}>
                                Intimation of Investor or Analysts Meet on 22.11.2023
                                </Col>
                                <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                  <a href={PDF_IMPORTS.STOCK_EXCHANGE_06} target="_blank" >
                                    <Icon type="file-pdf" className="margin-r-1 font-18" /> PDF
                                  </a>
                                </Col>
                              </Row>
                              <Row className="padding-t-1" align="middle" type="flex" justify="start" gutter={18}>
                                <Col xs={24} sm={24} md={16} lg={16} xl={16}>
                                Intimation of Investor or Analysts Meet on 10.10.2023
                                </Col>
                                <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                  <a href={PDF_IMPORTS.STOCK_EXCHANGE_02} target="_blank" >
                                    <Icon type="file-pdf" className="margin-r-1 font-18" /> PDF
                                  </a>
                                </Col>
                              </Row>
                            </Panel>
                          </Collapse>
                        </Panel>
                      </Collapse>
                    </Card>
                  </Col>
                </Row>
              </Container>
            </section>
            <Journey />
          </div>
        </StyledAnnualFinancials>
      </Fragment>
    );
  }
}


AnnualGeneralMeeting.propTypes = {
  history: shape({}).isRequired,
};
const component = AppWrappperHOC(AnnualGeneralMeeting);

export { AnnualGeneralMeeting };
export default component;



// WEBPACK FOOTER //
// client/containers/StaticPages/AnnualGeneralMeeting/index.js